import React from "react";
import {
  Button,
  FormFieldSet,
  InfoText,
  InfoTimeCard,
  Modal,
  PageHeader,
  useFormHandler,
} from "../../../../../../components";
import { dateFormator } from "../../../../../../utils";

const PaymentDiscountModal = ({ open, onClose, rowData }) => {
  console.log("rowData", rowData);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      waiveOffReason: "",
      discountWaiveOffAccount: "",
      discountWaiveOffAmount: "",
      comments: "",
      markAsEmployeePaymentReceived: [],
    },
    {
      waiveOffReason: {
        type: "text",
        required: true,
      },
    }
  );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form saved successfully:", formData);

      onClose();
    } else {
      console.log("errros : ", errors);
    }
  };
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="PAYMENT DISCOUNT"
      width="max-w-7xl"
    >
      <div className="p-2">
        <div>
          <PageHeader
            RightSection={
              <div className="flex gap-3">
                <InfoTimeCard
                  title="Invoice"
                  color="info"
                  value={rowData?.invoiceNumber}
                  //   suffix={"USD"}
                  type2
                />
                <InfoTimeCard
                  title="Received Amount"
                  color="success"
                  value={rowData?.paymentReceived}
                  suffix={"USD"}
                  type2
                />
                <InfoTimeCard
                  title="Invoice Amount"
                  color="info"
                  value={rowData?.invoiceAmount}
                  suffix={"USD"}
                  type2
                />
              </div>
            }
          />
          <div className="grid grid-cols-2 max-w-4xl mt-6 gap-x-0 gap-8">
            <InfoText title={"Net Terms"} value={"Net 30"} />
            <InfoText
              title={"Invoice Date"}
              value={
                rowData?.invoiceDate
                  ? dateFormator(rowData?.invoiceDate, "month-day-year")
                  : rowData?.invoiceDate || "--"
              }
            />
            <InfoText
              title={"Duea Date"}
              value={
                rowData?.dueDate
                  ? dateFormator(rowData?.dueDate, "month-day-year")
                  : rowData?.dueDate || "--"
              }
            />
            <InfoText title={"Shipped Date"} value={"03/10/2025"} />
          </div>
          <div className="grid grid-cols-3 max-w-7xl mt-8 gap-x-6 gap-8">
            <FormFieldSet
              type="select"
              title={"Waive-off Reason"}
              placeholder="Select Waive-off Reason"
              value={formData.waiveOffReason}
              onChange={(value) => handleChange("waiveOffReason", value)}
              error={errors.waiveOffReason}
            />
            <FormFieldSet
              type="select"
              title={"Discount/Waive-off Account"}
              placeholder=" select Discount/Waive-off Account"
              value={formData.discountWaiveOffAccount}
              onChange={(value) =>
                handleChange("discountWaiveOffAccount", value)
              }
              error={errors.discountWaiveOffAccount}
            />
            <FormFieldSet
              type="select"
              title={"Discount/Waive-off Amount"}
              placeholder="select Discount/Waive-off Amount"
              value={formData.discountWaiveOffAmount}
              onChange={(value) =>
                handleChange("discountWaiveOffAmount", value)
              }
              error={errors.discountWaiveOffAmount}
            />
            <FormFieldSet
              type="textArea"
              title={"Comments"}
              placeholder="Enter Comment"
              value={formData.comments}
              onChange={(value) => handleChange("comments", value)}
              error={errors.comments}
            />
            <FormFieldSet
              type="checkbox"
              size={"md"}
              title={""}
              options={[
                {
                  label: "Mark as Employee Payment Received",
                  value: true,
                },
              ]}
              values={formData.markAsEmployeePaymentReceived || []}
              onChange={(value) =>
                handleChange("markAsEmployeePaymentReceived", value)
              }
              multiple
              error={errors.markAsEmployeePaymentReceived}
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <Button title={"Close"} variant="outlined" onClick={onClose} />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default PaymentDiscountModal;
